import React from 'react';
import { BOOKING_HREF, handleBookingClick } from '../../utils/bookingNavigation';
import './UnderConstructionPage.css';

const UnderConstructionPage = ({ title }) => (
  <section className="under-construction">
    <div className="under-construction__inner">
      <span className="under-construction__tag">Coming Soon</span>
      <h1 className="under-construction__title">
        {title} is <span className="under-construction__accent">under construction.</span>
      </h1>
      <p className="under-construction__body">
        We are building this page right now. Please check back soon or book a free consultation
        and we can walk you through everything directly.
      </p>
      <a
        href={BOOKING_HREF}
        className="under-construction__cta"
        onClick={handleBookingClick}
      >
        Schedule a free consultation
      </a>
    </div>
  </section>
);

export default UnderConstructionPage;
